<h2 mat-dialog-title cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle style="cursor:move">
  Merge Fields
</h2>
<mat-dialog-content>
  <!-- <mat-table #table [dataSource]="dataSource" matSortDisableClear matSort id="tblMergeFields" matSortActive="Name" matSortDirection="asc">
  
    <ng-container matColumnDef="Name">
      <mat-header-cell *matHeaderCellDef mat-sort-header>  </mat-header-cell>
      <mat-cell *matCellDef="let element"> {{element.Name}} </mat-cell>
    </ng-container>
  
    <mat-row *matRowDef="let row; columns: columnsToDisplay; let i = renderIndex;" id="tblMergeFieldsDataRow{{i}}"
      style="padding:0px;overflow: hidden;" matRipple (click)="mergeFieldClicked(row)" (keydown)="dataSource.rowKeyPress($event, row)">
    </mat-row>

  </mat-table> -->
  <mat-list>
    <ng-container *ngFor="let listGroup of fieldList">
      <div style="padding-top:10px">{{listGroup.category}}</div>
      <mat-list-item *ngFor="let field of listGroup.fields" (click)="mergeFieldClicked(field)"><a>{{field.DisplayName}}</a></mat-list-item>
    </ng-container>
  </mat-list>
</mat-dialog-content>
<mat-dialog-actions>
  <div class='flex-footer-left'>

  </div>
  <div class='flex-footer-right'>
    <tyl-button image="cancel.png" label="Close" (clickEvent)="closeClick()"></tyl-button>
  </div>
</mat-dialog-actions>